import React, { useEffect, useState, useContext, useMemo, useRef } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Img } from 'react-image';
import _ from 'lodash';
import Modal from 'react-responsive-modal';
import { disableDarkMode } from "../../utils/darkMode"

import { Creators as NotificationsActions } from '../../store/ducks/notifications/actions';
import { Creators as AlertActions } from '../../store/ducks/alert/actions';
import { UserActions } from '../../store/ducks/user';

import { gateway } from '../../utils/api';

import FullLoading from '../shared/FullLoading';
import CartaoErro from '../CartaoErro';
import SmartBar from '../SmartBar';
import NavBarContext from '../../context/navBar/NavBarContext';
import GenericAlert from '../shared/GenericAlert';
import Notificacao from './Notificacao';
import ModalPolitica from '../Modals/ModalPolitica';
import ModalTenancy from './ModalTenancy';
import Video from '../ModalVideo/Video';
import history from '../../utils/history';

import hamburger from '../../images/hambuger.png';
import placeholder from '../../images/placeholder-avatar.png';
import styled from 'styled-components';
import * as Styles from './styles';
import { ModalRegisterPasswordMobile } from './ModalRegisterPasswordMobile';
import DarkMode from './DarkMode';

const LOGO_HOME_SAINTPAUL = require('../../images/logo-saintpaulwhite.png');

const MobileNavbarCollapse = styled.div`
  @media (max-width: 991px) {
    &.collapse.show,
    &.collapsing {
      background: ${props => props.menuBackgroundColor || '#27aae1'} !important;
    }
    
    /* Sobrescrever background quando dark mode estiver ativo */
    body.dark-mode &.collapse.show,
    body.dark-mode &.collapsing {
      background: #000000 !important;
    }
      padding: 1.5rem 1rem !important;
      margin-top: 0.5rem;
      border-radius: 0 0 12px 12px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      position: relative !important;
      z-index: 1000 !important;
      
      .form-large {
        width: 100% !important;
        margin-bottom: 1.5rem;
        
        .input-group {
          width: 100% !important;
          flex-direction: row !important;
          display: flex !important;
          
          .navbar-lit-search {
            flex: 1 !important;
            margin-left: 0 !important;
            border-radius: 8px 0 0 8px !important;
            padding: 12px 16px !important;
            font-size: 16px !important;
            background: rgba(255, 255, 255, 0.95) !important;
            color: #333 !important;
            border: 2px solid #27aae1 !important;
            border-right: none !important;
            
            &::placeholder {
              color: #999 !important;
              font-size: 14px;
            }
          }
          
          .input-group-append {
            width: auto !important;
            
            button {
              border-radius: 0 8px 8px 0 !important;
              padding: 12px 20px !important;
              background: #27aae1 !important;
              border: 2px solid #27aae1 !important;
              color: #fff !important;
              font-size: 16px;
              font-weight: 600;
              white-space: nowrap !important;
              
              i {
                margin-right: 8px;
              }
              
              &:hover {
                background: #1e8fc7 !important;
                border-color: #1e8fc7 !important;
              }
            }
          }
        }
      }
      
      ul#navbarNavDropdown {
        flex-direction: column !important;
        width: 100% !important;
        align-items: stretch !important;
        padding: 0 !important;
        margin: 0 !important;
        
        li {
          width: 100% !important;
          margin: 0.5rem 0 !important;
          text-align: left !important;
          
          a.nav-link {
            color: #fff !important;
            padding: 12px 16px !important;
            border-radius: 8px !important;
            background: rgba(255, 255, 255, 0.1) !important;
            margin: 0 !important;
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            transition: all 0.3s ease !important;
            min-height: 48px !important;
            font-size: 15px !important;
            font-weight: 500 !important;
            
            &:hover,
            &:focus {
              background: rgba(255, 255, 255, 0.2) !important;
              color: #fff !important;
              text-decoration: none !important;
            }
            
            &::after {
              display: inline-block !important;
              margin-left: auto !important;
              margin-right: 0 !important;
            }
          }
          
          .dropdown-toggle::after {
            margin-left: auto;
            border-top: 0.3em solid;
            border-right: 0.3em solid transparent;
            border-bottom: 0;
            border-left: 0.3em solid transparent;
          }
          
          .dropdown-menu {
            position: static !important;
            float: none !important;
            width: 100% !important;
            margin: 0.5rem 0 0 0 !important;
            padding: 0.5rem 0 !important;
            background: rgba(255, 255, 255, 0.15) !important;
            border: none !important;
            border-radius: 8px !important;
            box-shadow: none !important;
            max-height: 60vh !important;
            overflow-y: auto !important;
            
            .dropdown-item {
              color: #fff !important;
              padding: 12px 20px !important;
              text-align: left !important;
              border-radius: 0 !important;
              font-size: 15px !important;
              white-space: normal !important;
              
              &:hover,
              &:focus {
                background: rgba(255, 255, 255, 0.25) !important;
                color: #fff !important;
              }
              
              &:first-child {
                border-radius: 8px 8px 0 0 !important;
              }
              
              &:last-child {
                border-radius: 0 0 8px 8px !important;
              }
            }
            
            h4 {
              color: rgba(255, 255, 255, 0.9) !important;
              font-size: 14px !important;
              font-weight: 600 !important;
              text-transform: uppercase !important;
              letter-spacing: 0.5px !important;
              margin: 1rem 0 0.5rem 0 !important;
              padding: 0.75rem 20px 0.5rem !important;
              border-top: 1px solid rgba(255, 255, 255, 0.2) !important;
            }
            
            .divider {
              background: rgba(255, 255, 255, 0.2) !important;
              margin: 0.75rem 20px !important;
            }
          }
          
          .nav-item.dropdown {
            width: 100% !important;
            
            a.nav-link {
              display: flex !important;
              align-items: center !important;
              
              img {
                margin-right: 12px !important;
                margin-top: 0 !important;
              }
              
              span {
                display: flex !important;
                align-items: center !important;
                position: relative !important;
                
                .mobile-account-text {
                  display: none !important;
                  
                  @media (max-width: 991px) {
                    display: inline-block !important;
                    margin-left: 12px !important;
                    font-size: 15px !important;
                    font-weight: 500 !important;
                    color: #fff !important;
                    white-space: nowrap !important;
                    visibility: visible !important;
                    opacity: 1 !important;
                  }
                }
              }
              
              &::after {
                display: inline-block !important;
                margin-left: auto !important;
                border-top: 0.3em solid !important;
                border-right: 0.3em solid transparent !important;
                border-bottom: 0 !important;
                border-left: 0.3em solid transparent !important;
              }
            }
          }
          
          .nav-items-row {
            display: flex !important;
            flex-direction: row !important;
            width: 100% !important;
            gap: 0.5rem !important;
            margin: 0.5rem 0 !important;
            list-style: none !important;
            padding: 0 !important;
            
            .nav-item {
              flex: 1 !important;
              margin: 0 !important;
            }
            
            .mobile-notification-hidden {
              display: none !important;
            }
          }
          
          .nav-item:has(.buttonNotif),
          .nav-item:has([class*="DarkMode"]) {
            width: 100% !important;
            
            @media (max-width: 991px) {
              width: auto !important;
              flex: 1 !important;
            }
          }
          
          .buttonNotif {
            width: 100% !important;
            padding: 12px 16px !important;
            border-radius: 8px !important;
            background: rgba(255, 255, 255, 0.1) !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            position: relative !important;
            min-height: 48px !important;
            
            i {
              font-size: 20px !important;
              color: #fff !important;
            }
            
            .button__badge {
              position: absolute !important;
              top: 8px !important;
              right: 12px !important;
              background: #ff4444 !important;
              color: #fff !important;
              border-radius: 50% !important;
              min-width: 20px !important;
              height: 20px !important;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              font-size: 12px !important;
              font-weight: bold !important;
            }
            
            &:hover {
              background: rgba(255, 255, 255, 0.2) !important;
            }
          }
          
          .nav-item:has([class*="DarkMode"]) {
            a.nav-link,
            button,
            div {
              width: 100% !important;
              padding: 12px 16px !important;
              border-radius: 8px !important;
              background: rgba(255, 255, 255, 0.1) !important;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              min-height: 48px !important;
              border: none !important;
              color: #fff !important;
              font-size: 15px !important;
              font-weight: 500 !important;
              
              &:hover {
                background: rgba(255, 255, 255, 0.2) !important;
              }
            }
          }
          
          .nav-item a.nav-link[role="button"] {
            width: 100% !important;
            padding: 12px 16px !important;
            border-radius: 8px !important;
            background: rgba(255, 255, 255, 0.1) !important;
            border: none !important;
            color: #fff !important;
            font-size: 15px !important;
            font-weight: 500 !important;
            min-height: 48px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: flex-start !important;
            margin: 0.5rem 0 !important;
            
            i {
              margin-right: 12px !important;
              font-size: 18px !important;
            }
            
            &:hover,
            &:focus {
              background: rgba(255, 255, 255, 0.2) !important;
              color: #fff !important;
              text-decoration: none !important;
            }
          }
          
        }
      }
    }
  }
`;

function NavBarSuperior({
  home,
  courses,
  trialData,
  setSmartBar,
  searchText,
  noPosition,
  erroPagamento,
  showSmartBar,
  reviewSmartBar,
  removeSmartBar,
  setOpenPlans,
  setMyClasses,
  countNotificationsNotReadRequest,
  qtdNotif,
  perfil,
  toggleModalRestrict,
  toggleModalRestrictLitPass,
  match,
  onlyLogo,
}) {
  const {
    showGenericAlert,
    showRecommendationPlanAlert,
    hasExpiredOrNearExpirationInvoice,
    tenancy,
    tenantName,
    showLinkBoletos,
    showMyInvoicesButton,
    openModalRegisterMobilePassword
  } = useContext(NavBarContext);

  const [loading, setLoading] = useState(false);
  const [headerGradient, setHeaderGradient] = useState(true);
  const [classes, setClasses] = useState([]);
  const [urlBiblioteca, setUrlBiblioteca] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [showNotifications, setShowNotifications] = useState({
    display: 'none'
  });
  const [showModalPolitica, setShowModalPolitica] = useState(false);
  const [urlVideo, setUrlVideo] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [headerWidth, setHeaderWidth] = useState('100%');
  const [scrolled] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(() => 
    localStorage.getItem("darkmode") === "on" || 
    document.body.classList.contains("dark-mode")
  );
  const [searchTurma, setSearchTurma] = useState('');

  const settings = JSON.parse(localStorage.getItem('settings') || '{}');
  const tenant = localStorage.getItem('tenant') || '';
  const company = localStorage.getItem('company') || ' ';
  // Perfil ativo no tenant atual (um tenant pode ter vários perfis; só alguns possuem turma)
  const activeProfileLabel = _.get(
    _.find(
      _.get(_.find(tenancy, { tenancy: tenant }), 'profileTypes', []),
      { crCode: localStorage.getItem('crCodeProfile') }
    ),
    'typeLabel',
    ''
  );
  const freeUser = JSON.parse(localStorage.getItem('freeUser'));
  const libraryUser = JSON.parse(localStorage.getItem('libraryUser'));

  const showPaul = JSON.parse(localStorage.getItem('showPaul')) || null;
  const menuMaxWindow = window.window.innerHeight - 100;
  const urlImg = perfil.data.linkPhoto || placeholder;
  const { firstName, enableSocialName, socialName } = perfil.data;

  const { headerBackgroundColor, headerBackgroundGradient, primaryBackgroundColor } = _.get(
    settings,
    `${tenant}`,
    {}
  );
  
  // Monitorar mudanças no dark mode
  useEffect(() => {
    const checkDarkMode = () => {
      const darkModeActive = localStorage.getItem("darkmode") === "on" || 
                            document.body.classList.contains("dark-mode");
      setIsDarkMode(darkModeActive);
    };

    // Verificar inicialmente
    checkDarkMode();

    // Observar mudanças na classe do body
    const observer = new MutationObserver(() => {
      checkDarkMode();
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Observar mudanças no localStorage
    const handleStorageChange = () => {
      checkDarkMode();
    };
    window.addEventListener('storage', handleStorageChange);

    return () => {
      observer.disconnect();
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  // Obter cor de background do tenant ou usar padrão
  const getMenuBackgroundColor = () => {
    // Se dark mode estiver ativo, sobrescrever com preto
    if (isDarkMode) {
      return '#000000'; // Preto do dark mode
    }
    
    // Primeiro tenta usar headerBackgroundColor se headerGradient estiver ativo
    if (headerGradient && headerBackgroundColor) {
      return headerBackgroundColor;
    }
    // Se não, tenta usar primaryBackgroundColor
    if (primaryBackgroundColor) {
      return primaryBackgroundColor;
    }
    // Se não, tenta usar headerBackgroundColor mesmo sem gradient
    if (headerBackgroundColor) {
      return headerBackgroundColor;
    }
    // Se não tiver background, usar padrão do LIT business ou azul padrão
    return '#27aae1'; // Cor padrão do LIT
  };

  // Initialize from localStorage if available
  const isMounted = useRef(true);
  const [totvsRegistration, setTotvsRegistration] = useState(() => {
    const saved = localStorage.getItem('totvsRegistration');
    return saved ? JSON.parse(saved) : null;
  });

  // TODO - adicionar depois
  const emailValidate = JSON.parse(localStorage.getItem('emailValidate'));
  const hasPasswordMobileInLocalStorage = localStorage.getItem(
    'hasPasswordMobile'
  );
  const showButtonToRegisterMobilePassword = hasPasswordMobileInLocalStorage
    ? !JSON.parse(hasPasswordMobileInLocalStorage)
    : false;
  const showMessageError = localStorage.getItem(
    '57e0854551b1dca003c67c384c37a346'
  );

  useEffect(() => {
    isMounted.current = true;
    const savedData = localStorage.getItem('totvsRegistration') ? JSON.parse(localStorage.getItem('totvsRegistration')) : null;
    if ((!savedData || !savedData.hasRegistration) && process.env.REACT_APP_TOTVS_URL_REDIRECT) {
      const fetchRmData = async () => {
        try {
          const response = await gateway.get('/person/person/getTotvsData');
          if (isMounted.current && response.hasRegistration) {
            setTotvsRegistration(response);
            localStorage.setItem('totvsRegistration', JSON.stringify(response));
          }
        } catch (error) {
          console.error('Erro ao buscar matrícula da Totvs:', error);
        }
      };
      fetchRmData();
    } else if (isMounted.current) {
      setTotvsRegistration(savedData);
    }

    return () => {
      isMounted.current = false;
    };
  }, []);

  const getWidth = () =>
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  const getHeight = () =>
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;

  const checkSizeChanged = () => {
    const currentWidth = getWidth();
    const currentUrl = window.location.pathname;
    const urlSplashed = currentUrl.split('/');
    const isNewCourseScreen = urlSplashed.find(item => item === 'curso-novo');
    const sizeWidth =
      currentWidth >= 1920 && !isNewCourseScreen ? 1920 : '100%';
    setHeaderWidth(sizeWidth);
  };

  const checkContainerDivHeight = () => {
    const height = getHeight();
    const divElement = document.getElementById('root');
    const divHeight = divElement.clientHeight;
    if (divHeight < height) {
      document.getElementById('root').style.minHeight = `${height}px`;
    }
  };

  const handleScroll = () => {
    const messageIe = document.getElementById('message-ie');

    if (document.documentElement.scrollTop > 100) {
      setHeaderGradient(true);
      if (messageIe) messageIe.style.display = 'none';
    }
    if (document.documentElement.scrollTop === 0) {
      if (home && !courses) setHeaderGradient(false);
      if (messageIe) messageIe.style.display = 'block';
    }
  };

  const leave = () => {
    const tenant = localStorage.getItem('tenant');
    const logoutRedirectUrl = _.get(
      settings,
      `${tenant}.logoutRedirectUrl`,
      false
    );
    // Clear rmRegistration from localStorage on logout
    localStorage.removeItem('totvsRegistration');
    // Redux é persistido e o logout não recarrega a página: sem isso as turmas
    // deste usuário seriam regravadas e usadas no próximo login na mesma aba.
    setMyClasses([]);
    localStorage.clear();
    sessionStorage.clear();
    removeSmartBar();
    disableDarkMode()
    if (logoutRedirectUrl && logoutRedirectUrl !== 'false') {
      window.location.href = logoutRedirectUrl;
    }
    history.push(`/${tenant && tenant !== 'LIT_BUSINESS' ? tenant.toLowerCase() : ''}`);
  };

  const verifyStatusAccount = async () => {
    const nowDate = new Date().getDate();
    const nowMonth = new Date().getMonth();
    const dateLogin = localStorage.getItem('dateLogin');
    const newDate = dateLogin ? dateLogin.split('/') : null;
    if (!newDate || newDate[0] < nowDate || newDate[1] > nowMonth) {
      leave();
    }
  };

  const search = e => {
    e.preventDefault();

    if (inputValue === '' || inputValue.trim() === '') {
      return;
    }

    history.push(`/busca?s=${inputValue}`);
  };

  const handleInputChange = event => {
    setInputValue(event.target.value);
  };

  const fetchClasses = async () => {
    try {
      const response = await gateway('/webbff/lit_app_web/classes');
      const loginWithoutPassword = JSON.parse(
        localStorage.getItem('loginWithoutPassword')
      );
      const classes = response;
      setClasses(classes);
      setMyClasses(response);
      
      if(classes.length > 0 && !localStorage.getItem('selectedClassName')) {
        localStorage.setItem('selectedClassName', classes[0].name);
        localStorage.setItem('selectedClassCrCode', classes[0].organizationCode);
      }

      if (loginWithoutPassword) {
        setClasses(classes);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const listenerScroll = () => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  };

  useEffect(() => {
    isMounted.current = true;
    const loadDataAsync = async () => {
      if (isMounted.current) {
        await fetchClasses();
        if (!Object.keys(trialData).length) {
          const countDown = JSON.parse(localStorage.getItem('countDown'));
          if (countDown) {
            const data = {
              text: countDown.html,
              background: countDown.backgroundColor,
              timer: countDown.countDown,
              textbutton: countDown.buttonText
            };
            if (isMounted.current) {
              setSmartBar(data);
            }
          }
        }
        if (isMounted.current) {
          verifyStatusAccount();
          if (home && !courses) {
            setHeaderGradient(false);
          }
        }
      }
    };

    checkContainerDivHeight();
    loadDataAsync();
    listenerScroll();
    checkSizeChanged();

    let timeoutId = null;
    const resizeListener = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        if (isMounted.current) {
          checkSizeChanged();
        }
      }, 150);
    };

    window.addEventListener('resize', resizeListener);

    return () => {
      isMounted.current = false;
      window.removeEventListener('resize', resizeListener);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [home, courses, trialData]);


  const openLibrary = async () => {
    const idProfile = localStorage.getItem('idProfile');
    const urlTutorial = `/webbff/lit_app_web/library/getTutorialByUserIndex/${idProfile}/2/`;

    const libraryUser = JSON.parse(localStorage.getItem('libraryUser'));
    const naRealUser = JSON.parse(localStorage.getItem('naRealUser'));

    if (libraryUser && !naRealUser) {
      setLoading(true);

      try {
        const tutorial = await gateway.get(urlTutorial);
        if (!isMounted.current) return;
        
        const url = `webbff/lit_app_web/home/v2/library`;
        const response = await gateway.get(url);
        if (!isMounted.current) return;
        
        setUrlBiblioteca(response.url);
        if (tutorial.watched) {
          if (response) {
            setLoading(false);
            window.open(`${response.url}`, '_blank');
          }
        } else {
          setOpenModal(true);
          setUrlVideo(tutorial.url);
          setLoading(false);
        }
      } catch (error) {
        console.error(error);
        if (isMounted.current) {
          setLoading(false);
        }
      }
    } else {
      if (naRealUser) {
        toggleModalRestrict(true, 'book');
        return;
      }
      toggleModalRestrictLitPass(true, 'book');
    }
  };

  const handleOpenClassCallToAction = async classContent => {
    const selectedClass = classes.find(
      cl => cl.contentCode === classContent.contentCode
    );

    localStorage.setItem('homeCrCode', selectedClass.homeCrCode);

    history.push({
      pathname: `/turma/${classContent.contentCode}`,
      state: { turma: classContent }
    });
  };

  const handleSelectClass = async item => {
    localStorage.setItem('selectedClassName', item.name);
    localStorage.setItem('selectedClassCrCode', item.organizationCode);
    await handleOpenClassCallToAction(item);
  };

  const handleSelectDefaultHome = async () => {
    history.push(`/home`);
  };

  const handleSearchTurmaChange = (e) => {
    setSearchTurma(e.target.value);
  };

  const filteredClasses = useMemo(() => {
    if (!searchTurma.trim()) {
      return classes;
    }
    const searchLower = searchTurma.toLowerCase().trim();
    return classes.filter(item => 
      item.name.toLowerCase().includes(searchLower)
    );
  }, [classes, searchTurma]);

  let topPosition = '';

  if (emailValidate === false && !noPosition) {
    topPosition = 'top-position';
  } else {
    topPosition = '';
  }

  const openBiblioteca = () => {
    setOpenModal(false);
    window.open(urlBiblioteca, '_blank');
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  const hideNotificacoes = () => {
    setShowNotifications({
      display: 'none'
    });
  };

  const showNotificacoes = () => {
    setShowNotifications({
      display: 'flex'
    });
  };

  const countNotif = () => {
    countNotificationsNotReadRequest();
  };

  const navClasses = useMemo(() => {
    let classes = 'navbar navbar-expand-lg navbar-light navbar-lit';
    if ((showSmartBar || showGenericAlert) && reviewSmartBar && !courses)
      classes += ' sticky-top';
    if (headerGradient) {
      classes += ' navbar-lit-gradient';
    } else if (scrolled) {
      classes += ' navbar-lit-gradient';
    } else {
      classes += ' navbar-lit-light';
    }
    return classes;
  }, [headerGradient, scrolled]);

  useEffect(() => {
    if (searchText !== undefined && searchText !== inputValue) {
      setInputValue(searchText);
    }
  }, [searchText]);

  // Limpar busca quando o dropdown de turmas for fechado
  useEffect(() => {
    const dropdownElement = document.getElementById('navbarDropdownTurmasLink');
    if (!dropdownElement) return;

    const handleDropdownHidden = () => {
      setSearchTurma('');
    };

    dropdownElement.addEventListener('hidden.bs.dropdown', handleDropdownHidden);

    return () => {
      dropdownElement.removeEventListener('hidden.bs.dropdown', handleDropdownHidden);
    };
  }, []);

  const logoIfDomainHasSaintPaul = useMemo(() => {
    const hostname = window.location.hostname.toLowerCase();
    if (
      hostname === 'app.saintpaul.com.br' &&
      tenant === 'LIT_BUSINESS'
    ) {
      return LOGO_HOME_SAINTPAUL;
    }

    const hasTenant = settings && Object.prototype.hasOwnProperty.call(settings, tenant);
    return hasTenant ? _.get(settings[tenant], 'logoUrl', '') : '';
  }, [settings, tenant, LOGO_HOME_SAINTPAUL]);

  const showReturnToDefaultHome = useMemo(() => {
    const hasHome = window.location.pathname === '/home';
    return hasHome;
  }, [window.location]);

  return (
    <>
      {loading && (
        <FullLoading>
          <p style={{ fontWeight: 'bold' }} className="no-margin">
            AGUARDE
          </p>
          <p className="no-margin">Carregando Biblioteca virtual </p>
          <p className="no-margin">Bons Estudos!</p>
        </FullLoading>
      )}
      <>
        <div
          className={`${topPosition}`}
          style={
            courses
              ? { width: '100%', zIndex: '999' }
              : { width: '100%', position: 'fixed', zIndex: '1000' }
          }
        >
          {erroPagamento || (showMessageError === 'true' && <CartaoErro />)}

          {showSmartBar && reviewSmartBar && !courses && (
            <SmartBar
              text={trialData.text}
              background={trialData.background}
              onClose={removeSmartBar}
              redirectToPerfil={setOpenPlans}
              timer={trialData.timer}
              textbutton={trialData.textbutton}
            />
          )}

          {showGenericAlert && reviewSmartBar && !courses && (
            <GenericAlert color="#856404" bgColor="#fff3cd">
              Você possui um boleto vencido ou próximo a vencer, &nbsp;
              <Link to="/historico-de-pagamento">
                <b> clique para visualizar</b>
              </Link>
            </GenericAlert>
          )}

          {showRecommendationPlanAlert && home && (
            <GenericAlert color="#856404" bgColor="#fff3cd">
              Envie os convites para os dependentes do seu plano, &nbsp;
              <Link to="/perfilAluno?open=recommendationPlan">
                <b> clique aqui para fazer isso!</b>
              </Link>
            </GenericAlert>
          )}

          {hasExpiredOrNearExpirationInvoice && reviewSmartBar && !courses && (
            <GenericAlert color="#856404" bgColor="#fff3cd">
              Você possui um boleto vencido ou próximo a vencer, &nbsp;
              <Link to="/invoicePaymentView">
                <b> clique para visualizar</b>
              </Link>
              <sup>new</sup>
            </GenericAlert>
          )}

          <nav
            className={navClasses}
            style={{
              background: headerGradient ? headerBackgroundColor : '',
              width: headerWidth
            }}
          >
            <Styles.TenantImageLink
              className="nav-link"
              style={{ minWidth: 150, padding: '0rem 1rem' }}
            >
              <Link to="/home">
                {settings && settings[tenant] && settings[tenant].logoUrl ? (
                  <img
                    id="tenant-logo"
                    alt={tenantName}
                    src={logoIfDomainHasSaintPaul}
                    style={{ height: 55 }}
                  />
                ) : (
                  tenantName
                )}
              </Link>
            </Styles.TenantImageLink>

            <button
              className="navbar-toggler toggler-lit"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span
                className="navbar-toggler-icon"
                style={{
                  backgroundImage: `url(${hamburger})`,
                  filter: 'brightness(0) invert(1)'
                }}
              />
            </button>

            {!onlyLogo && (
              <MobileNavbarCollapse
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
                menuBackgroundColor={getMenuBackgroundColor()}
              >
                <div style={{ flex: '1' }}>
                  <form
                    className="form-inline my-2 my-lg-0 form-large"
                    onSubmit={search}
                  >
                    <div className="input-group col-lg-12">
                      <input
                        className="navbar-lit-search form-control border-right-0 search "
                        type="text"
                        value={inputValue}
                        placeholder="Busque por cursos, trilhas, professores, grupos, outros onlearners etc."
                        aria-label="Search"
                        onChange={handleInputChange}
                      />
                      <div className="input-group-append">
                        <button
                          type="button"
                          onClick={search}
                          className="btn border-left-0"
                          data-tip="Buscar"
                          style={{
                            borderRadius: '0 10px 10px 0',
                            color: 'rgba(255, 255, 255, 0.8)',
                            background: 'rgba(0, 0, 0, 0.3)',
                            border: '1px solid rgba(255,255,255, 0.25)'
                          }}
                        >
                          <i className="fa fa-search" />
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
  
                <ul
                  className="navbar-nav"
                  id="navbarNavDropdown"
                  style={{ flex: '1', justifyContent: 'flex-end' }}
                >
                  {classes && classes.length > 0 && (
                    <Styles.TurmasDropdownContainer>
                      <li className="nav-item dropdown">
                        <a
                          className="nav-link dropdown-toggle"
                          id="navbarDropdownTurmasLink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="true"
                        >
                          <span data-tip="Acesse seus cursos, tilhas e micro-momentos">
                            {localStorage.getItem('selectedClassName')
                              ? localStorage.getItem('selectedClassName')
                              : 'Turmas'}
                          </span>
                        </a>
                        <div
                          className="dropdown-menu dropdown-menu-right turmas-dropdown"
                          aria-labelledby="navbarDropdownTurmasLink"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div style={{ 
                            padding: '8px 0',
                            borderBottom: '1px solid #e0e0e0',
                            marginBottom: '8px',
                            position: 'sticky',
                            top: 0,
                            background: 'white',
                            zIndex: 1
                          }}>
                            <div style={{ position: 'relative' }}>
                              <i 
                                className="fa fa-search" 
                                style={{
                                  position: 'absolute',
                                  left: '12px',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  color: '#999',
                                  fontSize: '14px'
                                }}
                              />
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Buscar turma..."
                                value={searchTurma}
                                onChange={handleSearchTurmaChange}
                                onClick={(e) => e.stopPropagation()}
                                onFocus={(e) => e.stopPropagation()}
                                style={{
                                  fontSize: '14px',
                                  padding: '8px 12px 8px 35px',
                                  border: '1px solid #ddd',
                                  borderRadius: '4px',
                                  width: '100%',
                                  outline: 'none'
                                }}
                              />
                              {searchTurma && (
                                <i 
                                  className="fa fa-times" 
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setSearchTurma('');
                                    // Focar no input após limpar para manter o dropdown aberto
                                    const input = e.target.parentElement.querySelector('input');
                                    if (input) {
                                      input.focus();
                                    }
                                  }}
                                  onMouseDown={(e) => {
                                    e.preventDefault();
                                  }}
                                  style={{
                                    position: 'absolute',
                                    right: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    color: '#999',
                                    fontSize: '14px',
                                    cursor: 'pointer'
                                  }}
                                />
                              )}
                            </div>
                          </div>
                          <div>
                            {filteredClasses.length > 0 ? (
                              filteredClasses.map((item, index) => (
                                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                                <a
                                  key={index}
                                  onClick={() => {
                                    handleSelectClass(item);
                                    setSearchTurma('');
                                  }}
                                  className="dropdown-item"
                                  data-tip="Minhas turmas"
                                >
                                  {item.name}
                                </a>
                              ))
                            ) : (
                              <div style={{ 
                                padding: '12px',
                                textAlign: 'center',
                                color: '#999',
                                fontSize: '14px'
                              }}>
                                Nenhuma turma encontrada
                              </div>
                            )}
                          </div>
                          {!showReturnToDefaultHome && (
                            <div style={{ 
                              borderTop: '1px solid #e0e0e0',
                              marginTop: '8px',
                              paddingTop: '8px'
                            }}>
                              <a
                                onClick={() => {
                                  handleSelectDefaultHome();
                                  setSearchTurma('');
                                }}
                                className="dropdown-item"
                                role="button"
                                tabIndex="0"
                                aria-label="Voltar para home principal"
                                style={{
                                  fontWeight: '500'
                                }}
                              >
                                Voltar para home principal
                              </a>
                            </div>
                          )}
                        </div>
                      </li>
                    </Styles.TurmasDropdownContainer>
                  )}
                  {company.toUpperCase() === 'ANGLO' && (
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        href="https://maestro.plurall.net/#/bookshelf"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Apostilas
                      </a>
                    </li>
                  )}
                  <div className="nav-items-row">
                    {/*<li
                      className="nav-item dropdown mobile-notification-hidden"
                      style={{ alignSelf: 'center', margin: '0 5px' }}
                    >
                      <div
                        role="button"
                        onClick={() => showNotificacoes()}
                        className="buttonNotif"
                      >
                        <i className="fa fa-bell" aria-hidden="true" />
                        {qtdNotif > 0 && (
                          <div className="button__badge">{qtdNotif}</div>
                        )}
                        <Notificacao
                          hide={() => hideNotificacoes()}
                          showNotes={showNotifications}
                          countNotif={() => countNotif()}
                        />
                      </div>
                    </li>*/}
                    <li className="nav-item">
                      <DarkMode pathRoute={match.path} />
                    </li>
                  </div>
                  <Styles.DropDownMenuContainer
                    menuMaxWindow={menuMaxWindow}
                    className="nav-item dropdown"
                  >
                    <a
                      className="nav-link dropdown-toggle"
                      id="navbarDropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span>
                        <Img
                          className="rounded-circle"
                          style={{ width: 38, height: 38, marginTop: '-5px' }}
                          src={urlImg}
                        />
                        <span className="mobile-account-text pl-2 d-inline-block d-sm-none">Minha conta</span>
                      </span>
                    </a>
                    <div
                      className="dropdown-menu dropdown-menu-right"
                      aria-labelledby="navbarDropdownMenuLink"
                    >
                      <Link
                        to={
                          company.toLocaleUpperCase() !== 'ANGLO' &&
                          '/perfilAluno'
                        }
                        className="dropdown-item"
                      >
                        <Styles.HoverUserName>
                          Olá, {enableSocialName ? socialName : firstName}!
                        </Styles.HoverUserName>
                        <small>Área de Estudo: {tenantName}</small>
                        {activeProfileLabel && (
                          <small style={{ display: 'block' }}>Perfil: {activeProfileLabel}</small>
                        )}
                      </Link>
  
                      {showButtonToRegisterMobilePassword && (
                        <Styles.ButtonModal
                          onClick={() => openModalRegisterMobilePassword()}
                          type="button"
                          className="dropdown-item"
                        >
                          Cadastrar senha para o aplicativo
                        </Styles.ButtonModal>
                      )}
  
                      <Styles.MenuSectionTitle>
                        Dados da conta
                      </Styles.MenuSectionTitle>
                      {company.toUpperCase() !== 'ANGLO' && (
                        <Link
                          to="/perfilAluno"
                          className="dropdown-item"
                          data-tip="Conte-nos sobre você e defina suas preferências de privacidade"
                        >
                          Perfil
                        </Link>
                      )}
  
                      {showLinkBoletos && (
                        <Link
                          to="/historico-de-pagamento"
                          className="dropdown-item"
                          data-tip="Visualizar boletos"
                        >
                          Meus boletos
                        </Link>
                      )}
  
                      <a
                        role="button"
                        data-tip="Conheça nossa Politica e Privacidade"
                        className="dropdown-item"
                        onClick={() => setShowModalPolitica(true)}
                      >
                        Termos e Privacidade
                      </a>
                      {showPaul && (
                        <Link
                          to={{
                            pathname: '/chatPaul',
                            state: { fromNavBar: true }
                          }}
                          className="dropdown-item"
                        >
                          Sobre o LIT
                        </Link>
                      )}
  
                      {
                        <Link
                          to="/ajuda"
                          className="dropdown-item"
                          data-tip="Neste canal você pode tirar dúvidas, fazer elogios, sugerir melhorias, reportar erros e conhecer melhor a plataforma"
                        >
                          Fale conosco
                        </Link>
                      }
                      <Styles.MenuSectionTitle>Conteúdo</Styles.MenuSectionTitle>
  
                      <Link
                        to="/cursos"
                        className="dropdown-item"
                        data-tip="Cursos e trilhas que está cursando no momento"
                      >
                        Meus cursos
                      </Link>
  
                      {totvsRegistration && totvsRegistration.hasRegistration && (
                        <Link
                          to="/redirect-totvs"
                          className="dropdown-item"
                          data-tip="Acesse o Portal do Aluno"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          Portal do Aluno
                        </Link>
                      )}
  
                      {company.toUpperCase() !== 'ANGLO' && libraryUser && (
                        <a
                          className="dropdown-item"
                          role="button"
                          onClick={() => openLibrary()}
                          data-tip="Acesse mais de 8 mil títulos de temas diversos"
                        >
                          Ir para biblioteca
                        </a>
                      )}
  
                      <Styles.MenuSectionTitle>
                        Área de Estudo
                      </Styles.MenuSectionTitle>
  
                      <ModalTenancy
                        tenancy={tenancy}
                        settings={settings}
                        tenant={tenant}
                        tenantName={tenantName}
                      />
  
                      <Styles.Divider></Styles.Divider>
                      <a
                        onClick={() => leave()}
                        role="button"
                        className="dropdown-item"
                        data-tip="Log out da plataforma"
                      >
                        Sair
                      </a>
                    </div>
                  </Styles.DropDownMenuContainer>
                </ul>
              </MobileNavbarCollapse>
            )}

            <Modal
              open={openModal}
              onClose={() => closeModal()}
              classNames={{ modal: 'lit-perfil-form' }}
              closeOnOverlayClick={false}
            >
              <div className="modal-content">
                <div className="modal-header justify-content-center">
                  <h5 style={{ color: '#27aae1' }} className="modal-title">
                    Biblioteca
                  </h5>
                </div>
                <div className="modal-body">
                  <Video indexSubtitle={2} url={urlVideo} />
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      onClick={() => openBiblioteca()}
                      className="btn btn-nivelamento btn-FontWeight6"
                      style={{ marginTop: '1rem' }}
                    >
                      <a>Ir para biblioteca</a>
                    </button>
                  </div>
                </div>
              </div>
            </Modal>

            <ModalRegisterPasswordMobile />

            <ModalPolitica
              visible={showModalPolitica}
              onClose={() => {
                setShowModalPolitica(false);
              }}
            />
          </nav>
        </div>
      </>
    </>
  );
}

const mapStateToProps = store => {
  return {
    perfil: store.user.profile,
    erroPagamento: store.user.profile.erroPagamento,
    qtdNotif: store.notifications.qtdNotRead,
    showAlert: store.alert.show,
    type: store.alert.type,
    trialData: store.alert.trialData,
    showSmartBar: store.alert.showSmartBar
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...NotificationsActions,
      ...AlertActions,
      ...UserActions.ProfileActions,
      ...UserActions.StudyGroupActions
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NavBarSuperior)
);
